module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation",
    class: {
      'backward': !_vm.hasBeenPushed,
      'forward': _vm.hasBeenPushed
    }
  }, [_c('div', {
    staticClass: "toolbar bg-blue-400 color-white"
  }, [_c('button', {
    staticClass: "icon-button",
    class: {
      'hide': _vm.states.length <= 1
    },
    on: {
      "click": function($event) {
        _vm.previous()
      }
    }
  }, [_c('i', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("Yaniv Scores")]), _vm._v(" "), (_vm.rightIcon && _vm.rightAction) ? _c('span', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "icon-button",
    on: {
      "click": function($event) {
        _vm.rightAction()
      }
    }
  }, [_c('i', {
    class: _vm.rightIcon
  })])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "view-transition"
    }
  }, [_c(_vm.state, {
    key: "state",
    tag: "component",
    staticClass: "view",
    on: {
      "onPushState": _vm.onPushState,
      "onPopState": _vm.onPopState
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10c7a76d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainNav.vue
// module id = 107
// module chunks = 2